// extracted by mini-css-extract-plugin
module.exports = {"popoverContent":"Popover_popoverContent__fIJ5W","slideUp":"Popover_slideUp__9sAly","slideDown":"Popover_slideDown__HUJiU"};